import React, { Suspense } from 'react'
import { NotFound, Route, Switch, Redirect } from '@fs/zion-router'
import ErrorBoundary from '@fs/zion-error-boundary'
import { useEffectiveUser } from '@fs/zion-user'
import HomePageSkeleton from './components/HomePageSkeleton'

const HomePage = React.lazy(() => import('./components/HomePage'))
const WebToIndexPage = React.lazy(() => import('./components/WebToIndexPage'))
const AiAssistantChatLandingPage = React.lazy(() => import('./components/AiAssistantChatLandingPage'))
const AgentChatDemoPage = React.lazy(() => import('./components/agent-demo/AgentChatDemoPage'))

function App({ setHideFooter }) {
  const user = useEffectiveUser()

  return (
    <ErrorBoundary>
      <Suspense fallback={<HomePageSkeleton />}>
        <Switch>
          <Route exact path="/" component={HomePage} />
          <Route exact path="/web-to-index" component={WebToIndexPage} />
          <Route
            requirePersonalData
            exact
            path="/aiassistant/chat"
            render={() => <AiAssistantChatLandingPage user={user} setHideFooter={setHideFooter} />}
          />
          <Redirect exact from="/aiassistant" to="/aiassistant/chat" />

          <Route exact path="/agent-chat-demo" render={() => <AgentChatDemoPage setHideFooter={setHideFooter} />} />

          {/* blank page for performance testing purposes only */}
          <Route path="/blank" component={() => 'This page is intentionally left blank'} />

          <Route component={NotFound} />
        </Switch>
      </Suspense>
    </ErrorBoundary>
  )
}
export default App
